module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "container row"
  }, [_c('div', {
    staticClass: "link"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'thisism'
      }
    }
  }, [_vm._v("THISISM")])], 1), _vm._v(" "), _c('div', {
    staticClass: "link"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'video-archives'
      }
    }
  }, [_vm._v("VIDEO")])], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "link"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'more'
      }
    }
  }, [_vm._v("&MORE")])], 1), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "href": "http://blog.livedoor.jp/thisism/",
      "target": "_blank"
    }
  }, [_vm._v("BLOG")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "href": "mailto:thisismgml@gmail.com"
    }
  }, [_vm._v("CONTACT")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-10abd0de"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navigation.vue
// module id = 81
// module chunks = 0